<template>
  <form
    v-show="hasContent"
    @submit.prevent="onSubmit"
    class="form"
  >
    <div class="form__content">
      <slot />
    </div>
  </form>
</template>

<script>

export default {
  name: 'InputfieldForm',
  computed: {
    hasContent () {
      return !!this.$slots.default
    },
  },
  methods: {
    onSubmit (e) {
      this.$emit('submit', e)
    },
  },
}

</script>

<style lang="scss">

</style>
